import { PROFILE_TAB_DASHBOARD, PROFILE_TAB_DASHBOARD_SUCCESS, PROFILE_TAB_DASHBOARD_ERROR, PROFILE_TAB_DASHBOARD_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ProfileTabDashboard = (state = initialState, action) => {
  switch (action.type) {
    case PROFILE_TAB_DASHBOARD:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case PROFILE_TAB_DASHBOARD_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case PROFILE_TAB_DASHBOARD_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case PROFILE_TAB_DASHBOARD_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ProfileTabDashboard;
